import React, {useContext, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Button, Checkbox, Dimmer, Dropdown, Loader, Modal, Progress, Icon} from 'semantic-ui-react';
import {Expense} from './Expense';
import {AppContext} from '../../context/app/appContext';
import {TopBar} from '../common/TopBar';
import {Sidebar} from '../common/Sidebar';
import {toast} from 'react-toastify';
import AllUsers from '../pages/AllUsers';

const AddExpensesToProgramPageComponent = () => {

    const appContext = useContext(AppContext);
    const {id} = useParams()
    const [expenseCategories, setExpenseCategories] = useState(appContext.expenseCategories);
    const [programExpenseIds, setProgramExpenseIds] = useState([]);
    const [programExpenses, setProgramExpenses] = useState([])
    const [currentExpenseProgram, setCurrentExpenseProgram] = useState({});
    const [programName, setProgramName] = useState('');

    const [teamList, setTeamList] = useState([]);
    const [selectedTeams, setSelectedTeams] = useState([]);
    const [existingTeams, setExistingTeams] = useState([]);

    const [totalUtilization, setTotalUtilization] = useState(0);
    const [totalUtilizationPercentage, setTotalUtilizationPercentage] = useState(0);
    const [totalAvailableBudget, setTotalAvailableBudget] = useState(2000);

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [infoModalText, setInfoModalText] = useState('');

    const [approvedExpenses, setApprovedExpenses] = useState([])

    const myRef = React.createRef()

    useEffect(() => {
        if(appContext.expensePrograms.length){
            console.info({id});
            const allExpenseProgram = appContext.expensePrograms;
            var currentProgram = allExpenseProgram.filter(expense => {
                return expense.id === id
            })[0]
            setCurrentExpenseProgram(currentProgram);
            // console.info({currentExpenseProgram});
            setProgramExpenses(currentProgram.expenseCategories)
            setProgramExpenseIds( currentProgram.expenseCategories.map(category => {return category.expenseCategoryId}));
            console.log("Current ids: "+currentProgram.expenseCategories.map(category => {return category.expenseCategoryId}))
            setProgramName(currentProgram.name);
        }
    }, [appContext.expensePrograms]);

    console.log(currentExpenseProgram)
    console.log(programExpenseIds)
    console.log(programName)

    // useEffect(() => {
    //     appContext.setLoading();
    //     (async function getAssignedExpenseCategories() {
    //         const assignedExpenseCategories = await appContext.getExpenseProgramCategories(programExpenseIds);
    //         setActiveExpenseCategories(assignedExpenseCategories);
    //     })();
    // }, [programExpenseIds]);

    // useEffect(() => {
    //     const approvedExpensesTotal = appContext.teams.reduce((total, team) => {
    //         // console.info({perk}, {programPerks});
    //         if (team.expenseLimit) {
    //             return total + team.expenseLimit;
    //         } else {
    //             return total;
    //         }
    //     }, 0);
    //     setTotalUtilization(parseFloat(approvedExpensesTotal).toFixed(2));
    //     setTotalUtilizationPercentage(parseInt(approvedExpensesTotal / totalAvailableBudget * 100));
    //     setTotalAvailableBudget(totalAvailableBudget); // TODO: should be remaining amount of issuing balance after other team budget are taken
    // }, [appContext.expenses, programExpenses, totalAvailableBudget]);

    useEffect(() => {
        appContext.setLoading();
        (async function loadExpenseCategories() {
            await appContext.loadExpenseCategories();
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
                await appContext.setEmployees();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        (async function loadExpensePrograms() {
            await appContext.loadExpensePrograms();
        })();
    }, []);



    useEffect(() => {
        if(appContext.teams.length && appContext.expensePrograms.length){
            const orgPrograms = appContext.expensePrograms;
            const selectedTeams = [];
            const unassignedTeams = [];
            const inactiveProgramTeams = [];
            const validTeams = appContext.teams.filter(team => {return (team.expenseLimit && team.expenseLimit > 0)})

            for (const team of validTeams) {
                if (team.expenseProgramId && team.expenseProgramId.trim() === id) selectedTeams.push(team)
                if (!team.expenseProgramId || team.expenseProgramId === "") unassignedTeams.push(team)
                if (team.expenseProgramId && !orgPrograms.filter(program => {return program.id === team.expenseProgramId.trim()})[0].active) inactiveProgramTeams.push(team);
            }

            const allowedTeams = [...selectedTeams, ...unassignedTeams, ...inactiveProgramTeams];
            // const allowedTeams = [...selectedTeams];


            const teamList = allowedTeams.map(team => {
                return {key: team.id, value: team.id, text: team.name};
            });

            const selectedTeamIds = selectedTeams.map(team => team.id);

            console.info({teamList});
            setTeamList(teamList);
            setSelectedTeams(selectedTeamIds);
            setExistingTeams(selectedTeamIds);

            const totalBudget = appContext.teams.reduce((total, team) => {
                // const teamSize = team.size === 0 ? 1 : parseInt(team.size);
                console.info({team}, '');
                return total + (parseInt(team.expenseLimit));
            }, 0);
            console.info({totalBudget});
            setTotalAvailableBudget(totalBudget);
        }
        // eslint-disable-next-line
    }, [appContext.teams, appContext.expensePrograms]);


    const handleExpenseSelectionChange = (expenseId, selected) => {
        const selectedExpenses = expenseCategories.map(expense => {
            if (expense.id === expenseId) return {...expense, selected: !selected};
            return expense;
        });
        console.clear();
        console.table(selectedExpenses);
        setExpenseCategories(selectedExpenses);
    };

    useEffect(() => {
        appContext.setLoading();
        setExpenseCategories(appContext.expenseCategories);
        console.info({expenseCategories});
        appContext.setLoading(false);
        // eslint-disable-next-line
    }, [appContext.expenseCategories]);

    useEffect(() => {
        // TODO: add category utilization percentage

        var approvedExpensesData = []

        for (const programExpense of programExpenses) {
            const expenseId = programExpense.expenseCategoryId;
            const expenseItem = appContext.expenseCategories.filter(expense => {
                return expense.id === expenseId;
            });
            // console.info({perkItem});

            approvedExpensesData.push({
                expenseName: expenseItem.length && expenseItem[0].name !== undefined ? expenseItem[0].name : '',
                expensePrice: programExpense.spendingControl
            })
        }


        setApprovedExpenses(approvedExpensesData)
    }, [programExpenses, appContext.expenseCategories]);


    // const handleSubMenuItemClick = async (e) => {
    //     e.preventDefault();
    //     const name = e.target.innerText;
    //     setSubMenuActiveItem(name);

    //     const categoryName = name.trim().toLowerCase();
    //     console.info({categoryName});

    //     console.info({globalPerks: appContext.perks});

    //     const categoryPerks = (categoryName !== 'see all') ? appContext.perks.filter(perk => perk.categories.includes(categoryName.trim().toLowerCase())) : appContext.perks;

    //     console.info({categoryPerks});
    //     setPerks(categoryPerks);
    //     // history.push(`/perks/programs/${routeLink}`);
    // };

    const onTeamSelected = (event, {value}) => {
        event.preventDefault();
        console.info({value});
        setSelectedTeams(value);
        if(value.length === 0) setSelectedTeams([])
    };

    const setExpenseProgramTeamHandler = async () => {
        console.info({selectedTeams});
        const teamAssigned = await appContext.assignTeamsToExpenseProgram(id, selectedTeams);
        console.info({teamAssigned});
        if (!teamAssigned) {
            console.info(`Unable to assign teams to the expense program.`);
            setInfoModalText(`Unable to assign teams to the expense program.`);
            setShowInfoModal(true);
            setSelectedTeams(existingTeams);
            setExistingTeams(existingTeams);
        } else {
            setInfoModalText(`Expense program has been assigned to the selected team(s).`);
            setShowInfoModal(true);
            setExistingTeams(selectedTeams);
            setSelectedTeams(selectedTeams);
        }
    }

    const cancelHandler = async () => {
        setSelectedTeams(existingTeams);
    }

    const toggleSortProviderNames = () => {
        const sortedExpensesByProviderName = [...expenseCategories].sort((a, b) => a.name > b.name ? 1 : -1);
        setExpenseCategories(sortedExpensesByProviderName);
    };

    // const toggleSortPerkPrices = () => {
    //     const sortedPerksByPrice = [...perks].sort(
    //         (a, b) => a.price > b.price ? 1 : -1);
    //     setPerks(sortedPerksByPrice);
    // };

    const expenseRemoveHandler = async (expenseId, name) => {
        toast.dark(`${name} has been removed from the program.`);
        console.info(`Expense to remove: ${expenseId}`);
        const removed = await appContext.removeExpenseFromExpenseProgram({programId:id, expenseCategoryId: expenseId});
        console.info({removed});
        if (removed) setProgramExpenseIds(programExpenseIds.filter(progExpenseId => progExpenseId !== expenseId));
    }

    const expenseAddHandler = async (expenseId, spendingControl, name) => {
        toast.dark(`${name} has been added to the program.`);
        console.info(`Expense to add: ${expenseId}`);
        const added = await appContext.addToExpenseProgram({programId:id, expenseCategoryId: expenseId, spendingControl: spendingControl});
        console.info({added});
        if (added) setProgramExpenseIds([...programExpenseIds, expenseId]);
    }

    return (

        <div id="sub-page" style={{width: '90vw'}}>
            {/* <TopBar/>
            <div id="app-body"> */}

                {appContext.loading && (<Dimmer active inverted>
                    <Loader inverted inline='centered'>Loading</Loader>
                </Dimmer>)}

                {/* <div className="ui grid">
                    <div className="three wide column"><Sidebar/></div>
                    <div id="content" className="thirteen wide column"> */}

                        {/* --- page starts from here --- */}
                        <div id="add-perks-to-program-page" className="dashboard-page" style={{width: '90vw'}} ref={myRef}>
                            <header style={{backgroundColor: 'transparent'}}><h3 style={{backgroundColor: 'transparent', color: 'black'}}>{programName ? `Add Expense Categories to: ${programName}` : 'Expense Program Management'}</h3></header>

                            <div className="sub-page" id="add-expenses-to-program-page" style={{width: '90vw'}}>

                                <div className="ui grid" id="perk-management-menu" style={{width: '90vw'}}>
                                    <div className="twelve wide column">
                                        <Dropdown
                                            placeholder='For Teams'
                                            multiple
                                            fluid
                                            search
                                            selection
                                            options={teamList}
                                            onChange={onTeamSelected}
                                            value={selectedTeams}
                                        />
                                    </div>
                                    <div className="ui four wide column">
                                        {/* {!existingTeams === selectedTeams ?  */}
                                        <div className="ui two column grid">
                                            <div className="column right aligned">
                                                <button className="ui button" disabled={existingTeams === selectedTeams} onClick={cancelHandler}
                                                    style={existingTeams !== selectedTeams ? {backgroundColor: '#FCC65C'} : {}} >Cancel</button>
                                            </div>
                                            <div className="column">
                                                <button className="ui button" disabled={existingTeams === selectedTeams} onClick={setExpenseProgramTeamHandler}
                                                    style={existingTeams !== selectedTeams ? {backgroundColor: '#00CF8F'} : {}} >Save</button>
                                            </div>
                                        </div>
                                        {/* :null} */}
                                    </div>
                                </div>
                                {expenseCategories && expenseCategories !== [] ? 
                                <div className="ui grid" style={{width: '90vw'}}>
                                    <div className="ui twelve wide column" style={{paddingBottom: 0}}>
                                        {!expenseCategories.length && (<div className="ui segment center aligned"><h5>There are no expenses to be displayed.</h5></div>)}
                                        {expenseCategories.length > 0  &&
                                        (<table className="ui single line table perks" style={{backgroundColor: 'transparent'}}>
                                            <thead style={{backgroundColor: 'transparent'}}>
                                            <tr style={{backgroundColor: 'transparent'}}>
                                                {/* <th><Checkbox checked={allExpensesSelection} onChange={e => setAllExpensesSelection(!allExpensesSelection)}/></th> */}
                                                <th colspan="2" style={{backgroundColor: 'transparent'}} className="sortable-column"><span className="sortable-column" onClick={toggleSortProviderNames}>Expense Category<i
                                                    className='icon sort alphabet down'/></span></th>
                                                <th style={{backgroundColor: 'transparent'}} className="">Spending Controls</th>
                                                <th style={{backgroundColor: 'transparent'}} className="right aligned"></th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            {expenseCategories.map(expense => <Expense key={expense.id} {...expense} approved={programExpenseIds.includes(expense.id)} onApprove={expenseAddHandler}
                                                                     onSelect={handleExpenseSelectionChange} onRemove={expenseRemoveHandler} currentExpenseProgram={currentExpenseProgram} />)}

                                            </tbody>
                                        </table>)
                                        }
                                    </div>

                                    <div className="ui four wide column">
                                        <div id="budget-acquired-statics">
                                            {/* <div className="ui relaxed two column grid">
                                                <div className="column"><h3>Available budget:</h3></div>
                                                <div className="column">${totalAvailableBudget}</div>
                                                <div className="column"><h4>Total utilization:</h4></div>
                                                <div className="column"><p>${totalUtilization}</p></div>
                                            </div>

                                            <Progress percent={totalUtilizationPercentage} warning progress="percent"/>
                                            <h5 className="category-statics-heading">By
                                                Category:</h5>

                                            <br/> */}

                                            <div style={{marginTop: 15, marginBottom: 15}} >
                                                <div><h3>Approved Expenses</h3></div>
                                                <table className="ui single line table perks" style={{backgroundColor: 'transparent'}}>
                                                    <thead style={{backgroundColor: 'transparent'}}>
                                                        <tr style={{backgroundColor: 'transparent'}}>
                                                            <th style={{backgroundColor: 'transparent'}}><span onClick={toggleSortProviderNames}>Category<i
                                                                className='icon sort alphabet down'/></span></th>
                                                            <th style={{backgroundColor: 'transparent'}}><span>Spending Limit</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {approvedExpenses.map((expenseItem, index) => {
                                                            return <tr key={index} className="perk-item" style={{backgroundColor: 'rgba(238, 241, 243, 1)'}}>
                                                                    <td className="perk-provider">{expenseItem.expenseName}</td>
                                                                    <td>${expenseItem.expensePrice}</td>
                                                                </tr>
                                                            }
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* <div className="ui one column grid">
                                                <div className="column">
                                                    <Checkbox label="Copy Expense Budget Approver" disabled/>
                                                </div>
                                            </div>

                                            

                                            <div className="ui one column grid">
                                                <div className="column">
                                                    <a href="#top"
                                                       className="add-a-perk-product-to-perkfix">Add
                                                        an Expense Category to Perkfix.com</a>
                                                </div>
                                            </div> */}

                                        </div>
                                    </div>
                                </div>
                                : <div>No data to display</div>
                                }


                                <footer>
                                </footer>
                            </div>
                        </div>

                        <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                            <Modal.Content><p>{infoModalText}</p></Modal.Content>
                            <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
                        </Modal>
                        <Button icon onClick={() => {myRef.current.scrollIntoView({behavior: 'smooth'})}} style={{position: 'fixed', bottom: 30, right: 30, backgroundColor: 'transparent'}} ><Icon name="arrow alternate circle up" size='big'/></Button>
                        {/* --- page ends here --- */}

                    {/* </div>
                </div> */}
            {/* </div> */}
        </div>
    );
};

export const AddExpensesToProgramPage = AddExpensesToProgramPageComponent;
